import { render, staticRenderFns } from "./VeicoloList.vue?vue&type=template&id=5511cae3&"
import script from "./VeicoloList.vue?vue&type=script&lang=ts&"
export * from "./VeicoloList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports